import { Component, Input, OnInit } from "@angular/core";
import { TextBlock } from "../../models/text-block";
import { PublicTextBlockService } from "../../services/public-text-block.service";

@Component({
    selector: "app-text-block",
    templateUrl: "./text-block.component.html",
    styleUrls: ["./text-block.component.scss"],
    standalone: false
})
export class TextBlockComponent implements OnInit {
  @Input() blockCode: string;
  @Input() format: TextBlockFormat = TextBlockFormat.Card;

  textBlock: TextBlock;
  TextBlockFormat = TextBlockFormat;

  constructor(private publicTextBlockService: PublicTextBlockService) {}

  async ngOnInit(): Promise<void> {
    try {
      this.textBlock = await this.publicTextBlockService.getBlock(this.blockCode).toPromise();
    } catch (error) {
      console.warn(`Could not load text block with code: ${this.blockCode}`, error);
      this.textBlock = null;
    }
  }
}

export enum TextBlockFormat {
  Card = 1,
  Div = 2,
  Kendo = 3
}
